/* eslint-disable no-param-reassign */
import { util } from 'echarts';
import { type ThemeParser } from '../../../core/theme';

function parseColor(option: Parameters<ThemeParser>[0]) {
  const defaultColor = [
    '#265FFC',
    '#38D1FF',
    '#F564B9',
    '#733ED6',
    '#00DDCB',
    '#273D8F',
    '#FF7040',
    '#9EA9C7'
  ];
  option.color = option.color || util.clone(defaultColor);
}

export function colorThemeParse(...args: Parameters<ThemeParser>) {
  const [option] = args;

  parseColor(option);
}
